import { EventName } from '@lit/react';
import { BlocksToast } from 'blocks-nextjs/blocks-web-components/components/toast/toast';
import { BlocksCancelEvent, BlocksCloseEvent, BlocksOpenEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatToast = createComponent({
  react: React,
  tagName: 'cat-toast',
  elementClass: BlocksToast,
  events: {
    onBlToastClose: 'bl-toast-close' as EventName<BlocksCloseEvent>,
    onBlToastCancel: 'bl-toast-cancel' as EventName<BlocksCancelEvent>,
    onBlToastOpen: 'bl-toast-open' as EventName<BlocksOpenEvent>
  }
});
